import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Colors } from '../../../layout/theme-next';

export default makeStyles((theme: Theme) => ({
  groupCell: {
    whiteSpace: 'pre-wrap',
  },
  link: {
    fontSize: 14,
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1, 1),
  },
  statusIcon: {
    fontSize: 14,
  },
  confirmedIcon: {
    color: Colors.success,
  },
  unconfirmedIcon: {
    color: Colors.textDisabled,
  },
  lockedIcon: {
    color: Colors.error,
  },
}));
